/* unplugin-vue-components disabled */import { render } from "./item-mcq.vue?vue&type=template&id=5acc636e"
import script from "./item-mcq.vue?vue&type=script&lang=js"
export * from "./item-mcq.vue?vue&type=script&lang=js"

import "./item-mcq.vue?vue&type=style&index=0&id=5acc636e&lang=less&scope=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__